import React from "react";
import PropTypes from "prop-types";
import SuiBox from "components/SuiBox";

// Same tones as GoalStatusChip / GoalActionButton.
const TONES = {
  info: { fg: "#0b7c99", bg: "#e0f5fb" },
  success: { fg: "#0e7a2b", bg: "#e4f6e8" },
  warning: { fg: "#946200", bg: "#fff4d6" },
  error: { fg: "#c01616", bg: "#fde7e7" },
  secondary: { fg: "#4b5a73", bg: "#eef0f4" },
};

// Small rounded value pill (month range, percentages, totals).
function GoalPill({ children, color }) {
  const tone = TONES[color] || TONES.secondary;
  return (
    <SuiBox
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        height: 24,
        px: 1.25,
        borderRadius: "12px",
        fontSize: 12,
        fontWeight: 600,
        whiteSpace: "nowrap",
        color: `${tone.fg} !important`,
        backgroundColor: tone.bg,
      }}
    >
      {children}
    </SuiBox>
  );
}

GoalPill.defaultProps = { color: "secondary" };
GoalPill.propTypes = { children: PropTypes.node.isRequired, color: PropTypes.string };

export default GoalPill;
